module.exports = __webpack_public_path__ + "media/recipes/88-98fd69dd.png";